import styled from 'styled-components';

export const StyledExtendedProgressParent = styled.div`
  transform: translateX(0%);
  width: max-content;
  height: fit-content;
`;

export const StyledExtendedProgressContainer = styled.div`
  width: max-content;
  margin: 0 auto;
  background: ${({ theme }) => theme.COLORS.BASE};
  margin-left: 3px;
  border-radius: 0 3px 3px 0;
  box-sizing: border-box;
  box-shadow: 0px 1px 6px rgb(0 0 0 / 20%);
  animation: slide-out 1s forwards;

  @keyframes slide-out {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
`;

export const StyledExtendedText = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-style: normal;
  padding: 4px 7px;
  height: 100%;
  animation: progressbarCountdown;
  animation-duration: 5s;
  animation-delay: 0.3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-play-state: running;
  opacity: 0;

  @keyframes progressbarCountdown {
    0% {
      color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    }
    15% {
      opacity: 1;
      color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    }
    100% {
      color: #cbcbcb;
      opacity: 1;
    }
  }
`;
